module.exports = __webpack_public_path__ + "static/pic06-855c7b724833c23a7b1b1ee6c795a104.jpg";